<template>
  <OptionCard
      :info="{title: '关键词排名分析', desc: `${pageParams.startDateTime}~${pageParams.endDateTime}`, label: pageParams.dateLabel}"
      actions="refresh"
      @refresh="refresh">
    <app-base-main
        no-padding
        :table-shadow="false">
      <template #chart>
        <el-row :gutter="10">
          <el-col :span="12">
            <app-ad-keyword-rank-pie
                :loading="loading.pie"
                :data="data.pie"
            ></app-ad-keyword-rank-pie>
          </el-col>
          <el-col :span="12">
            <app-ad-keyword-rank-bar
                :loading="loading.bar"
                :data="data.bar"
            ></app-ad-keyword-rank-bar>
          </el-col>
        </el-row>
      </template>
      <template #table>
        <app-ad-keyword-rank-table
            :loading="loading.table"
            :data="data.table"
            show-country
            :pagination="pagination"
            :adapt-height="false"
            :height="400"
            border="default"
            @sort-change="$gjSortChange"
            @page-change="$gjNoticeQuery"
        ></app-ad-keyword-rank-table>
      </template>
    </app-base-main>
  </OptionCard>
</template>

<script>
  import {queryMixin} from "@/minxins";
  import {defaultVal} from "@/utils/common";
  import OptionCard from '@/views/components/option-card/option-card'
  import {KeywordRankEnum} from "@/views/modules/common/ad/rank/keyword-rank/enum";
  import AppAdKeywordRankPie from "@/views/modules/common/ad/rank/keyword-rank/charts/keyword-rank-pie";
  import AppAdKeywordRankBar from "@/views/modules/common/ad/rank/keyword-rank/charts/keyword-rank-bar";
  import AppAdKeywordRankTable from "@/views/modules/common/ad/rank/keyword-rank/keyword-rank-table";
  import {getKeywordRankingDistribution, getKeywordRankingDynamics, getKeywordRankingPage} from "@/api/statistics";

  export default {
    name: "app-ad-keyword-analysis",
    inject: ['getPageParams'],
    mixins: [queryMixin],
    components: {AppAdKeywordRankTable, AppAdKeywordRankBar, AppAdKeywordRankPie, OptionCard},
    data() {
      return {
        KeywordRankEnum: KeywordRankEnum,
        loading: {
          table: false,
          pie: false,
          bar: false,
        },
        data: {
          table: [],
          pie: null,
          bar: null
        }
      }
    },
    computed: {
      pageParams() {
        return this.getPageParams();
      },
    },
    watch: {
      pageParams() {
        this.$gjNoticeQuery();
      }
    },
    methods: {
      $gjQuery() {
        // 构造查询参数
        const params = {
          model: {
            marketIds: this.pageParams.countryData ? this.pageParams.countryData.marketIds : null,
            countryCodes: this.pageParams.countryData ? this.pageParams.countryData.countryIds : null,
            asinType: defaultVal(this.pageParams.asinType, null),
            asinCode: defaultVal(this.pageParams.asinCode, null),
          },
          ...this.queryPagination,
          ...this.querySort
        };
        // 保存全局参数
        this.globalParams = params;
        // 获取表格数据
        this.getTableData(params);
        // 获取饼图数据
        this.getPieData(params.model);
        // 获取柱状图数据
        this.getBarData(params.model);
      },
      getTableData(params) {
        // 查询
        this.loading.table = true;
        getKeywordRankingPage(params)
          .then(data => {
            this.data.table = data.records;
            this.pagination = this.getPagination(data);
          })
          .complete(() => this.loading.table = false);
      },
      getPieData(params) {
        this.loading.pie = true;
        getKeywordRankingDynamics(params)
          .then(data => {
            this.data.pie = data;
          })
          .complete(() => this.loading.pie = false);
      },
      getBarData(params) {
        this.loading.bar = true;
        getKeywordRankingDistribution(params)
          .then(data => {
            this.data.bar = data;
          })
          .complete(() => this.loading.bar = false);
      },
      refresh() {
        this.$gjNoticeQuery();
      },
    }
  }
</script>

<style scoped>
  /deep/ .rank-chart-wrapper {
    box-shadow: none;
    border: 1px solid #EBEEF5;
  }
</style>
